// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3KiOh","notes":"Notes_notes__1KznA","note":"Notes_note__2ALi0","markdown":"Notes_markdown__1wGUI"};